import { get, uniqBy } from 'lodash';
import arrayWrap from '../common/arrayWrap';

const filterByPerformance = (arr, perfNo) =>
  arr.filter(i => parseInt(i.perf_no, 10) === perfNo);

const filterByPackage = (arr, pkgNo) =>
  arr.filter(i => parseInt(i.pkg_no, 10) === pkgNo);

export default function(cart, perfNo, pkgNo) {
  let subLineItems = arrayWrap(get(cart, 'SubLineItem'));
  let packageSubLineItems = arrayWrap(get(cart, 'PackageSubLineItem'));

  /**
   * Filter out unseated package items so we don't try to process them.
   */
  packageSubLineItems = packageSubLineItems.filter(function(item) {
    return parseInt(item.seat_no, 10) !== 0;
  });

  /**
   * If we are editing a fixed package at the package level
   * then get a list of unique seats for the current package.
   */
  let combined;
  if (pkgNo) {
    let uniqItems = uniqBy(
      filterByPackage(packageSubLineItems, pkgNo),
      function(item) {
        return item.seat_no;
      }
    );

    combined = [].concat(uniqItems);
  } else {
    combined = [].concat(
      filterByPerformance(subLineItems, perfNo),
      filterByPerformance(packageSubLineItems, perfNo)
    );
  }

  return combined;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/cart/combineSubLineItems.js